<template>
	<div
		class="flex flex-col gap-12"
		itemscope
		itemtype="https://schema.org/LocalBusiness"
	>
		<div class="flex flex-col gap-4">
			<AtomTitle
				class="mb-4"
				tag="h2"
				size="sm"
			>
				Openingstijden
			</AtomTitle>
			<div
				v-for="day in openedAt"
				:key="`molecule-opening-hours-block-${day.day}`"
				class="flex flex-col gap-2"
			>
				<AtomTitle
					tag="h3"
					size="sm"
					itemprop="dayOfWeek"
					href="https://schema.org/Monday"
				>
					{{ translateDay(day.day) }}
				</AtomTitle>
				<div
					v-if="day.isOpen && day.openingHours"
					class="flex gap-2 items-center"
				>
					<time>{{ floatToTimeString(day.openingHours.from) }}u</time>
					<span>-</span>
					<time>{{ floatToTimeString(day.openingHours.till) }}u</time>
				</div>
				<span v-else>Gesloten</span>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
import type { OpeningHourType } from '#base/core/types/OpeningHourType';
import floatToTimeString from '#base/helpers/floatToTimeString';
import translateDay from '#base/helpers/translateDay';

defineProps<{
	openedAt: OpeningHourType[];
}>();
</script>
